module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/object/create"
// module id = 9
// module chunks = 0